module.exports = __webpack_public_path__ + "img/yellow_pet_glass.edd44c89.svg";